import { connect } from 'react-redux'
import { List } from 'immutable'
import { compose, withProps, withHandlers, lifecycle, branch, renderNothing } from 'recompose'

import { makeDefaultAvailabilityForTeam } from 'app/modules/teams/selectors'
import {
  DEFAULT_AVAILABILITY_SLOT,
  TeamAvailabilitySettings,
  AvailabilitySlotTime,
  AvailabilitySlot,
} from 'app/modules/teams/models'

import withOrgTeamAvailabilities from 'app/modules/teams/hoc/withOrgTeamAvailabilities'

import TeamAvailabilityPicker from './component'

const mapHoursToAvailabilitySlots = ta => {
  const teamAvailability = TeamAvailabilitySettings(ta)
  const mappedSlots = teamAvailability.openHours.map(hours => {
    const openTimes = hours.opens.split(':')
    const closeTimes = hours.closes.split(':')
    return AvailabilitySlot({
      dayOfWeek: hours.dayOfWeek,
      startTime: AvailabilitySlotTime({
        hour: parseInt(openTimes[0]),
        minutes: parseInt(openTimes[1]),
      }),
      endTime: AvailabilitySlotTime({
        hour: parseInt(closeTimes[0]),
        minutes: parseInt(closeTimes[1]),
      }),
    })
  })
  return teamAvailability.set('openHours', List(mappedSlots))
}

const mapStateToProps = (state, { team }) => {
  return {
    defaultSettings: makeDefaultAvailabilityForTeam(team.name)(state),
  }
}

export default compose(
  withOrgTeamAvailabilities,
  connect(mapStateToProps),
  withHandlers({
    emitSettingsChange: ({ onChange }) => settings => {
      onChange(settings)
    },
  }),
  lifecycle({
    componentDidMount() {
      const { createNew, team, teamAvailabilities, defaultSettings, emitSettingsChange } = this.props
      emitSettingsChange(
        createNew
          ? defaultSettings
          : mapHoursToAvailabilitySlots(teamAvailabilities.find(ta => ta.id === team.teamAvailabilityId))
      )
    },
  }),
  branch(({ settings }) => !settings, renderNothing),
  withHandlers({
    addSlot: ({ emitSettingsChange, settings }) => () => {
      emitSettingsChange(settings.set('openHours', settings.get('openHours').push(DEFAULT_AVAILABILITY_SLOT)))
    },
    removeSlot: ({ emitSettingsChange, settings }) => slot => {
      emitSettingsChange(settings.set('openHours', settings.get('openHours').remove(slot)))
    },
    selectTimezone: ({ emitSettingsChange, settings }) => ({ value }) => {
      emitSettingsChange(settings.set('timezone', value))
    },
    handleSelectDayOfWeek: ({ emitSettingsChange, settings }) => (slot, dayOfWeek) => {
      emitSettingsChange(settings.setIn(['openHours', slot, 'dayOfWeek'], dayOfWeek))
    },
    handleSelectStartTime: ({ emitSettingsChange, settings }) => (slot, startTime) => {
      emitSettingsChange(settings.setIn(['openHours', slot, 'startTime'], startTime))
    },
    handleSelectEndTime: ({ emitSettingsChange, settings }) => (slot, endTime) => {
      emitSettingsChange(settings.setIn(['openHours', slot, 'endTime'], endTime))
    },
  }),
  withProps(({ settings }) => ({
    showRemoveSlotUI: settings.get('openHours').size > 1,
  }))
)(TeamAvailabilityPicker)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Teams/TeamAvailabilityPicker/index.js